<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{data.title}}</h4>
    <div mat-dialog-content class="dialog-content text-muted">
        <form [formGroup]="accessGroup" class="row">
            <mat-form-field class="col-12" appearance="outline">
                <mat-label>Employee</mat-label>
                <mat-select [(ngModel)]="selectedUser" [ngModelOptions]="{standalone: true}"
                    (selectionChange)="onUserChange($event)" (openedChange)="onDropdownOpenChange($event)">
                    <mat-select-trigger>
                        {{ getUserName(selectedUser) || 'Select employee' }}
                    </mat-select-trigger>
                    <mat-option class="search-option">
                        <input #userSearchInput [(ngModel)]="userSearchText" [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="filterUsers()" (click)="$event.stopPropagation()"
                            (keydown)="$event.stopPropagation()" placeholder="Search employees..." class="search-input">
                    </mat-option>
                    <mat-option *ngFor="let item of filteredUsers" [value]="item.id">
                        {{item.name}}
                    </mat-option>
                    <mat-option *ngIf="filteredUsers.length === 0" disabled>
                        <em>No employees found</em>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
        <div *ngIf="data.type === 'admin'">
            <button mat-button class="btn btn-success yes-button" *ngIf="!isLoading; else loadingTemplate"
                cdkFocusInitial (click)="submit()" [disabled]="!accessGroup.valid">{{data.confirmText}}</button>
        </div>
        <div *ngIf="data.type === 'supervisor'">
            <button mat-button class="btn btn-success yes-button" *ngIf="!isLoading; else loadingTemplate"
                cdkFocusInitial (click)="submitSupervisor()"
                [disabled]="!accessGroup.valid">{{data.confirmText}}</button>
        </div>
        <div *ngIf="data.type === 'client-employee'">
            <button mat-button class="btn btn-success yes-button" *ngIf="!isLoading; else loadingTemplate"
                cdkFocusInitial (click)="submitClientEmployee()"
                [disabled]="!accessGroup.valid">{{data.confirmText}}</button>
        </div>
        <ng-template #loadingTemplate>
            <button mat-button class="btn btn-danger yes-button" cdkFocusInitial disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </ng-template>
    </div>
</div>